import React from "react";
import RaisedButton from "material-ui/RaisedButton";
import { connect } from "react-redux";
import { Card, CardText } from "material-ui/Card";
import {
  translate,
  changeLocale as changeLocaleAction,
  ViewTitle
} from "admin-on-rest";
import PassForm from "./custom/change_pass";

const styles = {
  label: { width: "10em", display: "inline-block" },
  button: { margin: "1em" }
};

const Configuration = ({
  theme,
  locale,
  changeTheme,
  changeLocale,
  translate
}) => (
  <Card>
    <ViewTitle title={translate("resources.configuration.name")} />
    <CardText>
      <div style={styles.label}>{translate("resources.language.name")}</div>
      <RaisedButton
        style={styles.button}
        label="en"
        primary={locale === "en"}
        onClick={() => changeLocale("en")}
      />
      <RaisedButton
        style={styles.button}
        label="el"
        primary={locale === "el"}
        onClick={() => changeLocale("el")}
      />
      <PassForm />
    </CardText>
  </Card>
);

const mapStateToProps = state => ({
  theme: state.theme,
  locale: state.locale
});

export default connect(
  mapStateToProps,
  { changeLocale: changeLocaleAction }
)(translate(Configuration));



// WEBPACK FOOTER //
// ./src/Dashboard.js